import { Flame, PenLine, Scale, Sparkles, Trophy, BrickWall, Utensils, Lock, Handshake, Sprout, Mountain } from "lucide-react";

// icon lookup by badge.icon field
const ICON_MAP = {
  flame: Flame,
  pen: PenLine,
  scale: Scale,
  spark: Sparkles,
  trophy: Trophy,
  brick: BrickWall,
  utensils: Utensils,
  sparkles: Sparkles,
  handshake: Handshake,
  sprout: Sprout,
  mountain: Mountain,
};

export default function BadgeCard({ badge }) {
  const Icon = ICON_MAP[badge.icon] || Sparkles;
  const earned = badge.earned;
  return (
    <div
      className="card card-interactive"
      data-testid={`badge-${badge.id}`}
      style={{
        opacity: earned ? 1 : 0.55,
        borderColor: earned ? "#FF0055" : "#27272A",
      }}
    >
      <div className="flex items-start gap-4">
        <div
          className="w-11 h-11 flex items-center justify-center shrink-0"
          style={{
            background: earned ? "#FF0055" : "#1A1A1A",
            border: `1px solid ${earned ? "#FF0055" : "#3f3f46"}`,
          }}
        >
          {earned ? <Icon size={20} color="white" strokeWidth={2.4} /> : <Lock size={18} color="#71717A" />}
        </div>
        <div className="flex-1">
          <p className="eyebrow" style={{ color: earned ? "#FF0055" : undefined }}>
            {earned ? "Earned" : "Locked"}
          </p>
          <p className="font-display font-bold uppercase mt-1 text-sm">{badge.name}</p>
          <p className="text-xs text-zinc-500 mt-1 leading-relaxed">{badge.desc}</p>
        </div>
      </div>
    </div>
  );
}
